export const tryParseQuillContents = (value: string) => {
  try {
    if (!value) {
      return [];
    }
    return JSON.parse(value);
  } catch {
    return [
      {
        insert: `${value}\n`,
      },
    ];
  }
};
